angular.
module("dx.webapp.api").
factory("dxApiV1ExamTemplates", function apiV1ExamTemplatesService(
	$http,
	$q,
	$window,

	Exam
) {
	"use strict";

	function getExamTemplatesList(archived) {
		var url = "/api/v1/examtemplates/list";
		var queryParams = {};

		if (typeof archived !== "undefined") {
			queryParams.archived = archived;
		}

		var queryString = $window.jQuery.param(queryParams);

		if (queryString) {
			url += "?" + queryString;
		}

		return $http.get(url).then(function success(response) {
			if (response.status <= 0) {
				return $q.reject();
			}

			response.data = initExams(response.data);
			return response;
		});
	}

	function examTemplatesQuestionsGet(examId) {
		return $http.get("/api/v1/examtemplates/" + examId + "/questions");
	}

	function initExams(rawExams) {
		var exams = [];
		for (var i = 0; i < rawExams.length; i++) {
			var exam = new Exam(rawExams[i]);
			exams.push(exam);
		}

		return exams;
	}

	function shareExamTemplatesRecipientsGet(examId) {
		return $http.get("api/v1/examtemplates/" + examId + "/shares/recipients");
	}

	function shareExamTemplatesRecipientDelete(examId, userId) {
		return $http.delete("api/v1/examtemplates/" + examId + "/shares?userId=" + userId);
	}

	// Fetches exams created from the given exam template.
	function examTemplateChildExamsGet(templateId) {
		return $http.get("api/v1/examtemplates/" + templateId + "/exams");
	}

	function hideExamTemplates(requestBody) {
		return $http.post("api/v1/examtemplates/sethidden", requestBody).then(function success(response) {
			response.data = new Exam(response.data);
			return response;
		});
	}

	return {
		get: getExamTemplatesList,
		hide: hideExamTemplates,
		questions: {
			get: examTemplatesQuestionsGet,
		},
		exams: {
			get: examTemplateChildExamsGet,
		},
		shares: {
			get: shareExamTemplatesRecipientsGet,
			delete: shareExamTemplatesRecipientDelete,
		},
	};
});
